/*global define*/
define(function () {

    'use strict';

    console.log('from config', SERVICES_URL);

    return {
        lang: $("html").attr("lang").toLowerCase(),
        ping_cloud : false,
        google_apikey : "AIzaSyA5MmbqZJOxNwBlAIMmpxIDktlQN7_izeY",
        // Services URL
        URL_elasticsearchapi : SERVICES_URL+"elasticSearchApi",
        URL_elasticrawdownload : SERVICES_URL+"wiewsExsituRawDownload",
        URL_indicator_rawdownload : SERVICES_URL+"wiewsIndicatorsRawDownload",     
        URL_pdf_export: SERVICES_URL+"wiewsExsituReportDownload",   
        //URL_bigquery_indicatorsearch : SERVICES_URL+"wiewsIndicatorsSearch",
        URL_bigquery_indicatorsearch : "https://wiews.fao.org/wiewsIndicatorsSearch",
        URL_bigquery: SERVICES_URL+"wiewsExsituSearch",
        URL_bigMap: SERVICES_URL+"wiewsExSituMapSearch",
        URL_bigSynonyms: SERVICES_URL+"wiewsExSituGetSynonyms",
        URL_bucket : "https://storage.googleapis.com/fao-wiews-lang-bucket/",
        // Remember to revert/delete
        URL_saiku :  SERVICES_URL+"pentaho/plugin/saiku/api/anonymousUser/query/execute",
        URL_saikumap : SERVICES_URL+"pentaho/plugin/saiku/api/anonymousUser/export/saiku/json?file=/home/anonymousUser/WIEWS/wiews_map_agg_{{YEAR}}_{{CROP}}"+$("html").attr("lang").toLowerCase()+".saiku",
        URL_monitoring :  SERVICES_URL+"wiewsNfpDotChartSearch",
        URL_monitoring_masterData :  SERVICES_URL+"wiewsnfpcodelist",
        URL_monitoring_nav : "https://www.fao.org/wiews/data/domains/detail/en/?code=",
        // Frontend URL
        URL_faowiews : "https://www.fao.org/wiews/",
        URL_metadata : "https://www.fao.org/wiews/metadata/indicator-",
        URL_exsitusearch : "https://www.fao.org/wiews/data/ex-situ-sdg-251/search/",
        URL_ExSitu:SERVICES_URL+"exSituDashboardOverview",
        URL_organizations : "https://www.fao.org/wiews/data/organizations/",
        URL_tropicos: "https://powo.science.kew.org/results?q=",
        URL_indicators : "https://www.fao.org/wiews/data/domains/domains-list/"+$("html").attr("lang").toLowerCase()+"/",
    };
});